import { asyncGetRequest } from '../../../api/requests';

export const getPublicGuides = async () => {
  return await asyncGetRequest('/api/app_content/public_local_guides');
};
